import React from "react";
import Verify from "./Verify";

const TransferYourBusiness = () => {
  return (
    <div>
      <Verify />
    </div>
  );
};

export default TransferYourBusiness;
